import React from 'react';

import { useScrollTo } from '@homesusa/core';
import { FormRefsContext } from '../contexts';

export const useFormRefs = (): {
  focusField: (fieldName?: string) => Promise<void>;
  clickTab: (tabId?: string) => Promise<void>;
  clickSubTab: (tabId?: string) => Promise<void>;
} => {
  const { fieldsRefs, tabsRefs, subTabsRefs, formReference } = React.useContext(FormRefsContext);
  const { scrollToTargetAdjusted } = useScrollTo(formReference);

  const delay = async (ms: number): Promise<void> => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const focusField = async (fieldName?: string): Promise<void> => {
    if (fieldName && fieldsRefs && fieldsRefs.current[fieldName]) {
      const field = fieldsRefs.current[fieldName];
      scrollToTargetAdjusted(field);
      await delay(100);

      const inputElem = field.querySelector('input,textarea,select');
      if (inputElem) {
        (inputElem as HTMLInputElement).focus();
      }
    }
  };

  const clickSubTab = async (tabId?: string): Promise<void> => {
    if (!subTabsRefs || !tabId) {
      return;
    }

    const tabIdRef = `subtab-${tabId}`;
    if (subTabsRefs.current[tabIdRef]) {
      subTabsRefs.current[tabIdRef].click();
      await delay(100);
    }
  };

  const clickTab = async (tabId?: string): Promise<void> => {
    if (!tabsRefs || !tabId) {
      return;
    }

    const tabIdRef = `tab-${tabId}`;
    if (tabsRefs.current[tabIdRef]) {
      tabsRefs.current[tabIdRef].click();
      await delay(100);
    }
  };

  return { focusField, clickTab, clickSubTab };
};
